import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from './services/account.service';
import { LoginViewModel } from './models/login-view-model';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { BrowserSupportTableComponent } from './shared-components/browser-support-table/browser-support-table.component';
import { Title } from '@angular/platform-browser';
import * as $ from 'jquery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'MyJSSI';
  checkMobileSupportMsg:string;
  notSupported: boolean = false;
  isMobile: boolean;

  constructor(private titleSvc: Title, private router: Router) {
    titleSvc.setTitle(this.title);

    router.events.subscribe((event: Event) => {

      if (event instanceof NavigationStart) {

        $('.router-content').animate({ scrollTop: 0 }, 'fast');
      }
    });

  }

  ngOnInit() {
    if (window.innerWidth <= 812 && window.innerHeight <= 812 && (
      navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
   )) {
     this.isMobile = true;
     sessionStorage.setItem('mobileSupportMsgView', 'seen');
     this.checkMobileSupportMsg =  sessionStorage.getItem('mobileSupportMsgView');
   } else {
     this.isMobile = false;
   }

    console.log('Checking broswer type and version', navigator.appVersion);
    if (navigator.appVersion.indexOf('MSIE 9') > -1
      || navigator.appVersion.indexOf('MSIE 8') > -1
      || navigator.appVersion.indexOf('MSIE 7') > -1
      || navigator.appVersion.indexOf('MSIE 6') > -1
      || navigator.appVersion.indexOf('MSIE 5') > -1) {
      this.notSupported = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts